var _path, _path2, _circle, _rect, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDoorstepSf(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6 16.936V3.366a.5.5 0 00-.5-.5H4.233a.5.5 0 00-.5.5V22.9a.5.5 0 00.5.5h6.51",
    stroke: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    d: "M.5 21.664h2.784M24.716 21.664H27.5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.27,
    cy: 12.704,
    r: 0.635,
    stroke: "#000"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.095,
    y: 17.366,
    width: 13.378,
    height: 8.838,
    rx: 1.5,
    stroke: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M11.351 20.15h12.865M16.649 20.65v.635a.5.5 0 00.5.5h1.27a.5.5 0 00.5-.5v-1.014M1.866 21.533V1.5a.5.5 0 01.5-.5h18.6a.5.5 0 01.5.5v15.736"
  })));
}
export default SvgIconDoorstepSf;